module.exports = __webpack_public_path__ + "static/media/auditB.e8066f18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/auditB.svg
// module id = 555
// module chunks = 0